import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dropdown-button",
  "use": "dropdown-button-usage",
  "viewBox": "0 0 13 3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 3\" id=\"dropdown-button\"><path d=\"M1.429 2.84c.789 0 1.428-.636 1.428-1.42C2.857.636 2.217 0 1.43 0 .639 0 0 .636 0 1.42c0 .784.64 1.42 1.429 1.42zm5 0c.789 0 1.428-.636 1.428-1.42C7.857.636 7.217 0 6.43 0 5.639 0 5 .636 5 1.42c0 .784.64 1.42 1.429 1.42zm5 0c.789 0 1.428-.636 1.428-1.42 0-.784-.64-1.42-1.428-1.42C10.639 0 10 .636 10 1.42c0 .784.64 1.42 1.429 1.42z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol